import React from 'react';
import {Button, Card, Col, Form, Row} from "react-bootstrap";
import {FloatFlexibleInput, FloatMarkInput} from "../common/MonetaryFloatInput";
import {dateRenderer, floatRenderer} from "../../services/formatSvc";
import Required from "../Required";
import FileInput from "../UI/upload/FileInput";
import {parseIsApprovedText} from "../../helpers/report";

const ExpertReportContent = ({readOnly,decision,canEdit,status,...props}) => {
    const {handleIsApprovedChange,handleDecisionDateChange,handleRecommendationsChange,handleProtocolChange,handleMarkChange, handleChangeFiles} = {...props?.callbacks}
    return (
        <React.Fragment>
            { !canEdit
                && (
                    <>
                        <Row className="mb-4">
                            <Col md={6}>
                                <Card.Subtitle className="mb-1 text-muted">Решение</Card.Subtitle>
                                <Card.Text>{parseIsApprovedText(status)}</Card.Text>
                            </Col>
                            <Col md={6}>
                                <Card.Subtitle className="mb-1 text-muted">Дата протокола</Card.Subtitle>
                                <Card.Text>{dateRenderer(decision.decisionDate)}</Card.Text>
                            </Col>
                        </Row>
                        <Row className="mb-4">
                            <Col md={12}>
                                <Card.Subtitle className="mb-1 text-muted">Рекомендации</Card.Subtitle>
                                <Card.Text>{decision.recommendations}</Card.Text>
                            </Col>
                        </Row>
                        <Row className="mb-4">
                            <Col md={12}>
                                <Card.Subtitle className="mb-1 text-muted">Оценка проекта (от 1 до 10, в т.ч. с округлением до десятых)</Card.Subtitle>
                                <Card.Text>{decision?.mark}</Card.Text>
                            </Col>
                        </Row>
                        <Row className="mb-4">
                            <Col md={6} className={'mb-2'}>
                                <Card.Subtitle className="mb-1 text-muted">Реквизиты протокола</Card.Subtitle>
                                <Card.Text>{decision.protocol}</Card.Text>
                            </Col>
                        </Row>
                    </>
                )}
            {/*{ !readOnly*/}
            {/*    && (*/}
            {/*        <Form.Group as={Col} md="12" style={{ marginBottom: '15px' }}>*/}
            {/*            <Form.Check onChange={() => handleIsApprovedChange(true)} checked={decision.isApproved} type="radio" id="radio-expert-approved" label="Одобрено на ЭГ" inline />*/}
            {/*            <Form.Check onChange={() => handleIsApprovedChange(false)} checked={!decision.isApproved} type="radio" id="radio-expert-not-approved" label="Не одобрено на ЭГ" inline />*/}
            {/*        </Form.Group>*/}
            {/*    )}*/}
            {canEdit && <React.Fragment>
            <Row className="mb-4">
                {readOnly && (
                    <Col md={6}>
                        <Card.Subtitle className="mb-2 text-muted">Решение</Card.Subtitle>
                        <Card.Text>{parseIsApprovedText(status)}</Card.Text>
                    </Col>
                )}
                {!readOnly && <Col md={6}>
                    <Form.Label>Решение</Form.Label>
                    <div>
                        <Form.Check onChange={() => handleIsApprovedChange(true)} checked={decision.isApproved} type="radio" id="radio-expert-approved" label="Одобрено на ЭГ" inline />
                        <Form.Check onChange={() => handleIsApprovedChange(false)} checked={!decision.isApproved} type="radio" id="radio-expert-not-approved" label="Не одобрено на ЭГ" inline />
                    </div>
                </Col>}
            </Row>
            <Row className="mb-4">
                <Form.Group as={Col} md="12">
                    <Form.Label>Рекомендации<Required/></Form.Label>
                    <Form.Control
                        required
                        readOnly={readOnly && !canEdit}
                        value={decision.recommendations}
                        onChange={handleRecommendationsChange}
                    />
                    <Form.Control.Feedback type="invalid">Необходимо указать рекомендации</Form.Control.Feedback>
                </Form.Group>
            </Row>

            <Row className="mb-4">
                <Col md={3}>
                    <Form.Label>Дата протокола</Form.Label>
                    <Form.Control
                        type="date"
                        readOnly={readOnly && !canEdit}
                        value={decision.decisionDate?.substring(0, 10)}
                        onChange={handleDecisionDateChange}
                    />
                    <Form.Control.Feedback type="invalid">Необходимо указать дату протокола</Form.Control.Feedback>
                </Col>
                <Form.Group as={Col} md="3">
                    <Form.Label>№ протокола</Form.Label>
                    <Form.Control
                        readOnly={readOnly && !canEdit}
                        value={decision.protocol}
                        onChange={handleProtocolChange}
                    />
                </Form.Group>

            </Row>
            <Row className="mb-4">
                <Form.Group as={Col} md="8">
                    <Form.Label>Оценка проекта (от 1 до 10, в т.ч. с округлением до десятых)<Required/></Form.Label>
                    <FloatFlexibleInput
                        required
                        value={decision?.mark}
                        thousandSeparator=" "
                        decimalScale={1}
                        placeholder="Укажите число от 0 до 10"
                        onChange={handleMarkChange}
                        isAllowed={(values) => {
                            const { formattedValue, floatValue } = values;
                            return formattedValue === '' || (floatValue >= 0 && floatValue <= 10);
                        }}
                    />
                    <Form.Control.Feedback type="invalid">Не введена оценка проекта</Form.Control.Feedback>
                </Form.Group>

            </Row>

                <Row className="mb-4">
                    <Form.Label>Файлы (.pdf)<Required/></Form.Label>
                    <Form.Group as={Col}>
                        <FileInput
                            required
                            validExtensions = {['pdf']}
                            customState
                            isMinio
                            downloadble
                            className={'reportFileForm'}
                            fileList={decision?.decisionFiles ?? []}
                            onFileChange={(newFiles) => {
                                handleChangeFiles(newFiles)
                            }}
                            onDeleteFile={(deleteId) => {
                                handleChangeFiles(decision.decisionFiles.filter(x=>x?.id && x?.id!==deleteId))
                            }}
                        />
                        <Form.Control.Feedback type="invalid">Обязательное поле к заполнению</Form.Control.Feedback>
                    </Form.Group>
                </Row>
            </React.Fragment>}
        </React.Fragment>
    );
};

export default ExpertReportContent;
